export default __webpack_public_path__ + "static/media/certs-4.f4253289.png";